import React from 'react';
import { render } from 'react-dom';
import SelectYourX from './selectYourX';
import { connect } from 'react-redux';
import { brandSelected } from '../actions/brandActions';
import { deviceSelected } from '../actions/deviceActions';
import { dropdownIndex } from '../actions/selectYourXIndexActions';

class SelectYourPrinter extends React.Component {
    constructor() {
        super();
        this.deviceSelected = this.deviceSelected.bind(this);
        this.brandSelected = this.brandSelected.bind(this);
    }
    deviceSelected(deviceId) {
        this.props.deviceSelected(this.props.selectedBrandId, deviceId, this.props.finderTypeId);
    }
    brandSelected(brandId) {
        this.props.brandSelected(brandId, this.props.finderTypeId);
    }
    createRoutePrefix(params) {
        let routePrefix = '';
        $.each(params, function (key, value) {
            routePrefix += encodeURIComponent(value) + '/';
        });

        return (routePrefix);
    }
    prepParameterForURL(parameter) {
        parameter = parameter.replace(/,/g, "~c~");
        return encodeURIComponent(decodeURIComponent(parameter));
    }
    createUrlPrefix(brandId, deviceId) {

        let queryString = '?Finder=Type||' + this.props.finderTypeId +
            '&Finder=Manufacturer||' + this.prepParameterForURL(brandId) +
            '&Finder=Device||' + this.prepParameterForURL(deviceId) +
            '&Finder=Model||';

        let urlPrefix = this.searchResultsPath(this.props.searchPageName, queryString);

        return (urlPrefix);
    }
    // This function is a temparary hack until we have a navigation function with token logic.
    searchResultsPath(pageName, queryString) {
        let pathName = location.pathname.substring(0, location.pathname.lastIndexOf('/') + 1);
        let basePath = location.href.substring(0, location.href.length - ((location.pathname + location.search + location.hash).length - pathName.length));

        return (basePath + pageName + queryString);
    }
    doesSelectedValueExistInArrayForSelection(decodedParam, dropdownArray) {
        return dropdownArray.some(x => x.description.toLowerCase() === decodedParam.toLowerCase());
    }
    setSelectedValue(routeParamName, dropdownArray) {
        let decodedItem = decodeURIComponent(routeParamName);
        return dropdownArray && this.doesSelectedValueExistInArrayForSelection(decodedItem, dropdownArray) ? decodedItem : null;
    }
    render() {
        return (
            <div className="row select-your-printer">
                <div className="col-md-4">
                    <SelectYourX selectedValue={this.setSelectedValue(this.props.routeMatchParams.manufacturer, this.props.brands)}
                        arrayForSelection={this.props.brands}
                        selectYourXDropdownIndex={dropdownIndex.brand}
                        buttonText={"Select Printer Brand"}
                        filterPlaceholderText={" Search for a Brand"}
                        queryString={this.props.queryString}
                        callBack={this.brandSelected} />
                </div>
                <div className="col-md-4">
                    <SelectYourX selectedValue={this.setSelectedValue(this.props.routeMatchParams.device, this.props.devices)}
                        arrayForSelection={this.props.devices}
                        selectYourXDropdownIndex={dropdownIndex.device}
                        buttonText={"Select Printer Series"}
                        filterPlaceholderText={" Search for a Series"}
                        callBack={this.deviceSelected}
                        queryString={this.props.queryString}
                        routePrefix={
                            this.createRoutePrefix([
                                this.props.selectedBrandId
                            ])
                        } />
                </div>
                <div className="col-md-4">
                    <SelectYourX selectedValue={this.props.routeMatchParams.model}
                        arrayForSelection={this.props.models}
                        selectYourXDropdownIndex={dropdownIndex.model}
                        buttonText={"Select Printer Model"}
                        filterPlaceholderText={" Search for a Model"}
                        queryString={this.props.queryString}
                        urlPrefix={
                            this.createUrlPrefix(
                                this.props.selectedBrandId,
                                this.props.selectedDeviceId
                            )
                        }
                        urlSuffix={this.props.urlSuffix} />
                </div>
            </div>
        );
    }
}
function mapStateToProps(state, ownProps) {
    return {
        brands: state.brands,
        devices: state.devices,
        models: state.models,
        selectYourXIndex: state.selectYourXIndex,
        selectedBrandId: state.selectedBrandId,
        selectedDeviceId: state.selectedDeviceId,
        configPropValues: state.configPropValues,
        finderTypeId: state.finderTypeId
    };
}
function mapDispatchToProps(dispatch) {
    return {
        brandSelected: (e, f) => dispatch(brandSelected(e, f)),
        deviceSelected: (e, f, g) => dispatch(deviceSelected(e, f, g))
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(SelectYourPrinter);  